export const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOjEsInJvbGUiOiJhZG1pbiIsImlhdCI6MTY5MjgxMjMzNSwiZXhwIjoxNjk1NDA0MzM1fQ.VWmSahbjKAdNxlmVmlITfZQTXF3EsPWJcWy_W4t60Bo"

// export const token2 = ""

export const baseURL = "https://apiludo.welcomesmm.com/";

// export const baseURL = "https://backened.ludokavish.com/api/v1";
// export const baseURL = "https://1t4f35fh-3000.inc1.devtunnels.ms/api/v1";